module.exports = __webpack_public_path__ + "assets/img/person_icon_b.fdd9a07f.png";